import script from "./AgentTestNumberSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentTestNumberSection.vue?vue&type=script&setup=true&lang=js"

import "./AgentTestNumberSection.vue?vue&type=style&index=0&id=da9f99b8&lang=css"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import WizardButton from "@/components/neue/wizard/WizardButton.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { WizardButton, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { WizardButton, WizardSection }, script.__o.components);}